import { css } from "lit";

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
	}

	.head {
		flex: 0 0 30px;
		display: flex;
		flex-direction: row;
		border-bottom: 1px solid var(--og-bucket-border-color);
	}

	.head > * {
		flex: 1;
		text-align: center;
		height: 100%;
	}

	.head > .project-select {
		border-right: 1px solid var(--og-bucket-border-color);
		border-radius: 0;
	}

	.head > og-dropdown-menu {
		flex: 0 0 30px;
	}

	.body {
		flex: 1;
		overflow: hidden;
		display: block;
		width: 100%;
		height: 100%;
		position: relative;
	}

	og-accordion {
		height: 100%;
		border: none;
	}

	og-tree {
		height: 100%;
	}

`;
